import { findAppIcon, findAppImageSlot, isValidAppAssetValue } from '../app-assets/index.js';
const isTree = (value) => typeof value === 'object' && value !== null && !Array.isArray(value);
const isKnown = (kind, name) => kind === 'icons' ? findAppIcon(name) !== undefined : findAppImageSlot(name) !== undefined;
const isAddress = (value) => isValidAppAssetValue(value) && value !== '';
export function validateAssetsPayload(kind, payload) {
    if (!isTree(payload))
        return { ok: false, errors: [`asset.${kind}: must be an object`] };
    const errors = [];
    const assets = {};
    for (const [name, value] of Object.entries(payload)) {
        if (!isKnown(kind, name))
            errors.push(`${name}: not an app ${kind === 'icons' ? 'icon' : 'picture slot'}`);
        else if (!isAddress(value))
            errors.push(`${name}: must be an uploaded http(s) address`);
        else
            assets[name] = value;
    }
    return errors.length ? { ok: false, errors } : { ok: true, payload: assets, errors };
}
export function mergeAssetsPayload(kind, _builtIn, received) {
    if (!isTree(received))
        return null;
    const assets = {};
    for (const [name, value] of Object.entries(received))
        if (isKnown(kind, name) && isAddress(value))
            assets[name] = value;
    return assets;
}
//# sourceMappingURL=asset-files.js.map